<template>
  <el-row class="ttn-response cp">
    <el-col :span="12">
      <el-row class="ttn-response__info">Погрузка: {{ item.load_date | getHumanDate }}</el-row>
      <el-row class="ttn-response__info">{{ getLoad(item) }}</el-row>
      <el-row class="ttn-response__info">{{ getUnload(item) }}</el-row>
      <el-row class="ttn-response__info">Заказчик: {{ item.exporter_name }}</el-row>
      <el-row class="ttn-response__info">Перевозчик: {{ item.driver_carrier_name }}</el-row>
      <el-row class="ttn-response__info">Водитель: {{ item.driver_fio }}</el-row>
    </el-col>
    <el-col :span="12" class="ta-r">
      <el-row class="plate_truck--title">Авто:</el-row>
      <el-row class="plate_truck fw-b">{{ item.state_numbers }}</el-row>
      <el-row class="plate_truck--title">Прицеп:</el-row>
      <el-row class="plate_truck fw-b">{{ item.state_numbers_trailer }}</el-row>
      <el-row>{{ item.carrier_name }}</el-row>
    </el-col>
    <el-row v-if="ttns.length" class="ta-r new-ttn">
      <el-button type="text" class="cp td-u" @click="$emit('new')">
        Создать новую ТТН
      </el-button>
    </el-row>
    <el-col v-if="ttns.length" class="docs-col">
      <el-row type="flex">
        <div class="ttns-title">существующие ТТН:</div>
        <div class="ttns-items">
          <el-button
            v-for="ttn in ttns"
            :key="ttn.id"
            type="text"
            class="cp td-u"
            @click="$emit('ttn')"
          >
            {{ getTTNInfo(ttn) }}
          </el-button>
        </div>
      </el-row>
    </el-col>
    <el-col v-if="act" class="docs-col">
      <el-row type="flex">
        <div class="ttns-title">существующий Акт:</div>
        <div>{{ act }}</div>
      </el-row>
    </el-col>
  </el-row>
</template>

<script>
import shippingMixin from '@/mixins/shippingMixin'

export default {
  name: 'TtnResponse',
  mixins: [shippingMixin],
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    act: {
      type: String,
      default: '',
    },
    ttns: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getLoad(item) {
      return `${this.loadLocationFilter(item)}, ${
        item.load_point.split(',')[0]
      }`
    },
    getUnload(item) {
      return `${this.loadLocationFilter(item, 'unload_point')}, ${
        item.load_point.split(',')[1]
      }`
    },
    getTTNInfo(ttn) {
      const { number, date } = ttn
      const day = this.dateToFormat(date, 'shortDateWithoutYear')

      return number && day ? `${number} от ${day}` : ''
    },
  },
}
</script>

<style lang="sass">
.ttn-response
  margin: 15px 0
  background: #fff
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.2)
  &:first-child
    margin-top: 10px
  .el-col
    padding: 10px 20px
    line-height: 18px
    .plate_truck--title
      font-size: 16px
      line-height: 20px
    .plate_truck
      font-size: 24px
      line-height: 1
      font-weight: bold
      margin-bottom: 10px
  .ttns-title
    margin-right: 20px
    width: 150px
  .ttns-items
    width: calc(100% - 170px)
  .el-button--text
    padding: 0
    margin-right: 10px
  .el-button+.el-button
    margin-left: 0
  .new-ttn
    margin-bottom: 10px
  .docs-col
    padding: 0 20px 10px
  &__info
    word-break: break-word
</style>
